export enum SlideKey {
  Previous = 'previous',
  Current = 'current',
  Next = 'next',
}
